import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { RedirectToPhp } from '@freelancer/redirect-to-php';
import { of } from 'rxjs';

export const HomePageGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const redirectToPhp = inject(RedirectToPhp);

  if (route.queryParams.w === 't') {
    return of(true);
  }

  if (route.queryParams.w === 'f') {
    return redirectToPhp.doRedirect(state.url);
  }

  return of(true);
};
